
/**
 * DeleteInspecaoPatrimonioItensUseCase
 */

import { IDeleteInspecaoPatrimonioItensUseCase } from "../../../presentation/useCases/delete/delete_inspecao_patrimonio_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class DeleteInspecaoPatrimonioItensUseCase implements IDeleteInspecaoPatrimonioItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteInspecaoPatrimonioItens(idInspecaoPatrimonioItens: number): Promise<void> {
    await this.repository.deleteInspecaoPatrimonioItens(idInspecaoPatrimonioItens);
  }
}
